export const isExternalLink = (url) => {
  if (!url) return false;
  const pattern = /^https?:\/\//i;
  return pattern.test(url);
};
